import React from 'react'
import {render} from 'react-dom'
import {Router, useRouterHistory, applyRouterMiddleware} from 'react-router'
import {compose, createStore, applyMiddleware} from 'redux'
import {Provider} from 'react-redux'
import {routerMiddleware, syncHistoryWithStore} from 'react-router-redux'
import useScroll from 'react-router-scroll'
import {persistState} from 'redux-devtools'
import {createHistory as createHtml5History, createHashHistory} from 'history'
import debug from 'debug'
import moment from 'moment'
import {supportHistory} from './core/browser'
import {appQueryParameters} from './core/locationz'
import applyActor from './core/redux/applyActor'
import {loadingMiddleware} from './core/redux/loading'
import {progressMiddleware} from './core/redux/progress'
import {statusMiddleware} from './core/redux/status'
import {subscribeMiddleware} from './core/redux/subscribe'
import {delayMiddleware} from './core/redux/delay'
import config from './config'
import i18n from './i18n'
import {thunk, promise, worker, errorStatus, error} from './app/middlewares'
import {unauthorized} from './user/middlewares'
import reducers from './app/reducers'
import routes from './app/routes'
import actors from './app/actors'
import hydrate from './app/hydrate'
import errors, {errorHandler, unhandledRejectionHandler} from './app/errors'

// config logger
debug.enable('*')

// config moment
moment.updateLocale('fr', i18n.moment)
moment.locale('fr')

var storeEnhancers = []

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

if (config.env == 'development') {

    storeEnhancers.push(...[
        persistState(window.location.href.match(/[?&]debug_session=([^&]+)\b/))
    ])

    if (module.hot) {
        // Enable Webpack hot module replacement for reducers
        module.hot.accept('./app/reducers', () => {
            store.replaceReducer(require('./app/reducers').default)
        })
    }
}

const browserHistory = supportHistory() && useRouterHistory(createHtml5History)() || useRouterHistory(createHashHistory)({queryKey: false})

const enhancer = composeEnhancers(
    applyActor(...actors),
    applyMiddleware(delayMiddleware, loadingMiddleware, progressMiddleware, subscribeMiddleware, thunk, promise, worker, error, unauthorized('/login'), errorStatus(errors), statusMiddleware, routerMiddleware(browserHistory)),
    ...storeEnhancers
)
const store = createStore(reducers, {...hydrate(), ...queryParameters()}, enhancer)

const history = syncHistoryWithStore(browserHistory, store, {selectLocationState: (s) => s.router})

function routeDispatcher(dispatcher) {
    return (nextState, replaceState, callback) => {
        Promise.resolve(dispatcher(store.dispatch, nextState.params, nextState.location.query)).catch((error) => {
            if (error && error.statusCode) {
                // functional error
                const state = store.getState()
                const nextLocation = state.router.history[0]
                const previousLocation = state.router.history[1]
                const targetLocation = nextState.location

                const location = previousLocation || (targetLocation.pathname != '/tickets' && {pathname: '/tickets'}) // fallback to home page

                if (nextLocation.pathname != targetLocation.pathname) {
                    // a redirect occured during dispatch
                    // keep redirect location
                    replaceState(nextLocation)
                } else if (location) {
                    // go back to previous location
                    replaceState(location)
                } else {
                    callback()
                }
                return
            }
            return Promise.reject(error)
        }).then((action) => {
            const state = store.getState()
            const nextLocation = state.router.location
            const targetLocation = nextState.location

            if (nextLocation.pathname != targetLocation.pathname) {
                // a redirect occured during dispatch
                // keep redirect location
                replaceState(nextLocation)
            } else {
                callback()
            }
        })
    }
}

function queryParameters() {
    const encodedState = appQueryParameters(window.location).state

    if (encodedState) {
        return JSON.parse(atob(encodedState))
    }
    return {}
}

render(
    <Provider store={store}>
        <div>
            <Router
                routes={routes(routeDispatcher, store)}
                history={history}
                render={applyRouterMiddleware(useScroll())} />
        </div>
    </Provider>
    ,
    document.getElementById('root')
)

window.onerror = errorHandler
window.onunhandledrejection = unhandledRejectionHandler




// WEBPACK FOOTER //
// ./lib/index.js